// extracted by mini-css-extract-plugin
export default {"row":"BrandRow_row__f++yB","brandImage":"BrandRow_brandImage__nCFnd","info":"BrandRow_info__6vDTD","name":"BrandRow_name__ZGbYL","share":"BrandRow_share__qFQV9"};